// this file is generated by update_shopify_store_data.py at 2026-06-22 20:30:09.952876
var courses = [
    {
        "course_id": "94889F7D-4CBA-F011-99A1-005056A7C0C7",
        "course_version": 2,
        "name": "Springer Publishing - CHPN\u00ae Certification Online Review",
        "course_type": 1,
        "author_information": "Springer Publishing",
        "description": "Prepare for the Certified Hospice and Palliative Nurse (CHPN\u00ae) certification exam with a comprehensive online review aligned to the latest exam outline. This course features learning modules with audio narration, knowledge check questions, and a full-length practice test to strengthen test-taking skills and boost exam-day confidence. \r\n\r\nCHPN\u00ae is a registered trademark of the Hospice and Palliative Nurses Association (HPNA). The HPNA does not endorse this resource, nor does it have a proprietary relationship with Springer Publishing Company.",
        "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe key concepts and clinical knowledge areas related to hospice and palliative nursing practice.</li>\r\n    <li>Apply critical-thinking and clinical judgment skills to manage complex symptoms and support patients and families across the continuum of care.</li>\r\n    <li>Demonstrate readiness for the CHPN&reg; certification exam through self-assessment activities.</li>\r\n</ul>",
        "course_outline_html": "<ul>\r\n    <li>Introduction</li>\r\n    <li>Certification Exam</li>\r\n    <li>Exam Preparation</li>\r\n    <li>Goals of Care and Shared Decision-Making</li>\r\n    <li>Interdisciplinary Care Planning and Ongoing Evaluation</li>\r\n    <li>Disease Progression and Imminent Death</li>\r\n    <li>Pain Etiology, Types of Pain, and Pain Syndromes</li>\r\n    <li>Pain Assessment</li>\r\n    <li>Pain Management Interventions</li>\r\n    <li>Neurologic Symptom Management</li>\r\n    <li>Cardiovascular Symptom Management</li>\r\n    <li>Respiratory Symptom Management</li>\r\n    <li>Gastrointestinal and Genitourinary Symptom Management</li>\r\n    <li>Musculoskeletal Symptom Management</li>\r\n    <li>Skin and Mucous Membrane Symptom Management</li>\r\n    <li>Nutritional and Metabolic Symptom Management</li>\r\n    <li>Immune, Lymphatic, and Hematologic Symptom Management</li>\r\n    <li>Psychosocial, Spiritual, and Cultural Needs</li>\r\n    <li>Patient and Caregiver Education, Support, and Advocacy</li>\r\n    <li>National Hospice and Palliative Care Standards</li>\r\n    <li>Hospice and Palliative Care Nursing Practice Issues</li>\r\n</ul>",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "6C3323AC-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Pain Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Procedures",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                "course_category_name": "All Settings",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Professional Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0E5C0830-D7C9-E511-82AF-005056B150D3",
                "course_category_name": "Patient Experience",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "70E3AB84-25C9-E511-8771-005056B104B1",
                "course_category_name": "Hospice and Palliative Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A2B7FF67-CEC9-E511-82AF-005056B150D3",
                "course_category_name": "End of Life Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30C21A06-4DBA-F011-99A1-005056A7C0C7",
                "course_category_name": "Springer Publishing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A010654-ECD9-F011-99A4-005056A7F5E9",
                "course_category_name": "Springer Publishing - Single Courses for Purchase (NGL)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "66608656-21BB-F011-99A1-005056A7C0C7",
                "course_category_name": "Springer Publishing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                "course_category_name": "Hospice",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    }
];